<template>
  <div>
      <box-border line></box-border>
      <div class="box" style="height: 405px;background: rgba(7,17,32,.3);">
         <div style="display: flex">

           <div style="display: flex;height: 100%;flex-direction: column" class="flex1">
             <box-header title="站点概况"></box-header>

             <div class="flex1 display-f margin-t5"  style="align-content: unset">
               <img style="width: 90px;height: 75px" src="../../assets/image/dian.png"/>
               <div class="title-main">
                 <div>汽车充电站数</div>
                 <div class="title-num">{{pileNum}}</div>
               </div>
             </div>

             <div class="flex1 display-f margin-t5" style="align-content: unset">
               <img  style="width: 90px;height: 75px"  src="../../assets/image/you.png"/>
               <div class="title-main">
                 <div>加油站数量</div>
                 <div class="title-num">{{gasNum}}</div>
               </div>
             </div>

             <div  class="flex1 display-f margin-t5"  style="align-content: unset">
               <img   style="width: 90px;height: 75px" src="../../assets/image/qi.png"/>
               <div class="title-main">
                 <div>加气站数量</div>
                 <div class="title-num">{{airNum}}</div>
               </div>
             </div>

             <div  class="flex1 display-f margin-t5"  style="align-content: unset">
               <img  style="width: 90px;height: 75px" src="../../assets/image/ranqi.png"/>
               <div class="title-main">
                 <div>燃气场站数量</div>
                 <div class="title-num">1</div>
               </div>
             </div>
           </div>

           <div style="display: flex;flex: 2">
             <div style="display: flex;flex-direction: column;flex: 1">
               <box-header title="会员统计"></box-header>
               <div class="flex1 display-f margin-t5"  style="align-content: unset">
                 <img style="width: 90px;height: 75px" src="../../assets/image/customer.png"/>
                 <div class="title-main">
                   <div>会员总数</div>
                   <countTo style="color: #5cebf6;" :startVal="oldTotalCount" :endVal="totalCount" class="title-value" />
                 </div>
               </div>

               <div class="flex1 display-f margin-t5"  style="align-content: unset">
                 <img style="width: 90px;height: 75px" src="../../assets/image/converter_station_count.png"/>
                 <div class="title-main">
                   <div>汽车换电站数</div>
                   <countTo style="color: #5cebf6;" :startVal="oldAddCount" :endVal="addCount" class="title-value" />
                 </div>
               </div>

               <div class="flex1 display-f margin-t5"  style="align-content: unset">
                 <img style="width: 90px;height: 75px" src="../../assets/image/erlun.png"/>
                 <div class="title-main">
                   <div>电动自行车站数</div>
                   <div class="title-num">{{erlunNum}}</div>
                 </div>
               </div>

               <div class="flex1 display-f margin-t5"  style="align-content: unset">
               </div>
            </div>

             <div class="flex1">
               <div id="chartHYTJ" class="chart" style="height: 90%"></div>
             </div>
           </div>
         </div>
      </div>
  </div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
import countTo from "vue-count-to";

export default {
  mounted() {
    this.$nextTick(() => {
      this.chart = this.$echarts.init(document.getElementById("chartHYTJ"));
      this.getStaticAssetsNum();
      this.getData();
    });
  },
  name: "DashboardOverview",
  components: {BoxBorder, BoxHeader, countTo},
  data(){
    return {
       pileNum:0,
       gasNum:0,
       airNum:0,
       erlunNum:0,
       oldTotalCount: 0,
       oldAddCount: 3,
       totalCount: 0,
       addCount: 3,
       dataList: []
    }
  },
  methods:{
    getStaticAssetsNum(){
      this.$api.getData_StaticAssetsNum()
          .then(res => {
            this.pileNum = res.data.pileCount;
            this.gasNum = res.data.gasStation;
            this.airNum = res.data.airStation;
          })
    },
    getData(){
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)"
      });
      this.$api.getPeopleObj().then(res => {this.disposeData(res.data)});
      //获取二轮车站点数量
      this.$api.getBicycleStationCount().then(res=>{
          if(res.succeed){
            this.erlunNum = res.data
          }
      })
    },
    disposeData(sourceData) {
      this.oldTotalCount = sourceData.totalCustomer;
      // this.oldAddCount = sourceData.addCustomer;
      this.totalCount =  sourceData.totalCustomer;
      // this.addCount = sourceData.addCustomer;
      this.dataList = [
        {
          name: "充电会员",
          value: sourceData.customerCount
        },
        {
          name: "加油/气会员",
          value: sourceData.gasCount
        }
      ];
      this.renderChart();
    },
    renderChart(){
      this.chart.hideLoading();
      let options = {
        color: ["rgba(67,211,104,1)", "#4093FF", "#FFD828", "#F54F5A"],
        grid: {
          left: 0,
          right: 0
        },
        legend: {
          show: true,
          orient: "vertical",
          bottom: 'bottom',
          left: -10,
          textStyle: {
            fontFamily: "Alibaba PuHuiTi",
            padding: 10,
            height: 26,
            rich: {
              a: {
                color: "rgba(211, 238, 254, 1)",
                fontSize: 24,
                fontWeight: "bold"
              },
              b: {
                color: "rgba(174, 244, 255, 1)",
                fontSize: 24,
                lineHeight: 50,
                fontWeight: "bold"
              }
            }
          },
          formatter: (name) => {
            const curr = this.dataList.find(item => item.name === name);
            return ["{a|" + curr.name + "}", "\n", "{b|" + curr.value + "人}"];
          }
        },
        series: [
          {
            name: "会员统计",
            type: "pie",
            center: ["45%", "40%"],
            radius: ["45%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
                textStyle: {
                  fontFamily: "Alibaba PuHuiTi",
                  padding: 10,
                  height: 26,
                  rich: {
                    a: {
                      color: "rgba(211, 238, 254, 1)",
                      fontSize: 24,
                      fontWeight: "bold",
                      marginTop: -20
                    },
                    b: {
                      color: "rgba(174, 244, 255, 1)",
                      fontSize: 30,
                      lineHeight: 50,
                      fontWeight: "bold"
                    }
                  }
                },
                formatter: ({data, percent}) => {
                  return "{a|" + data.name + "}\n{b|" + percent + "%}";
                }
              }
            },
            labelLine: {
              show: false
            },
            data: this.dataList
          }
        ]
      };
      this.chart.setOption(options);
    }
  }
};
</script>

<style scoped lang="scss">
.overview{
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 30px;
  .overview-item{
    position: relative;
    width: 280px;
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .item-bg{
      position: absolute;
      width: 100%;
      height: 100%;
      background: url("../../assets/image/bg_profile.png") no-repeat center center / cover;
      -webkit-animation: animal 10s infinite linear ;
      -webkit-transform-origin: center center;
      -ms-transform-origin: center center;
      transform-origin: center center;
    }
    .item-title{
      font-size: 32px;
      font-family: "screen", serif;
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, 0.56), 0 0 1em rgba(82, 163, 255, 0.56);
      box-sizing: border-box;
      margin-top: 15px;
    }
    .item-value{
      font-size: 48px;
      color: #0CC874;
      font-family: "screen", serif;
      line-height: 70px;
    }
  }
}

.title-main{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 28px;
  color: rgb(181, 228, 255);
  font-family: "screen";
  box-sizing: border-box;
  padding: 5px 20px 20px 10px;
  height: 75px;

  .title-num{
    color: #5cebf6;
  }
}


@-webkit-keyframes animal {
  0%{
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
</style>
